<template>
  <div class="view-container">
    <div id="update">
      <div class="container">
          <div class="row header">
              <h3 style="color: white;">Platinum Online Ordering</h3>
              <p style="color: white;">Online Ordering System</p>
          </div>
          <div class="row">
              <div class="col-md-12">
                  <div class="current-status">
                      <div class="status">
                          <div class="color red"></div>
                          It seems your franchise does not have access to the Online Ordering feature.
                      </div>
                      <div class="help">
                          <small>- Please contact the system administrator to activate this functionality.</small>
                      </div>
                  </div>
              </div>
          </div>
      </div>
    </div>
  </div>
</template>
<!-- Scripts -->
<script>
export default {
  name: "OrdersUnavailable",
  components: {
  },
  data() {
    return {}
  },
  created() {
  },
  mounted() {
  }
};
</script>
<style>
    @import './OrdersUnavailable.vue.css'; 
</style>
